import matchingExplainabilityType from './action-types'
import { FetchMatchingExplainabilityActionPayload } from './types'

export type MatchingExplaiabilityAction = ReturnType<typeof fetchMatchingExplainability>

export const fetchMatchingExplainability = (payload: FetchMatchingExplainabilityActionPayload) => ({
  type: matchingExplainabilityType.ENTITY_FETCH_BEGIN,
  payload,
})
